export enum MissionType {
  potokFM = 'potok-fm',
  keaz = 'keaz',
  toir = 'toir'
}
